import { render, staticRenderFns } from "./GlobalIngredientsList.vue?vue&type=template&id=4a726d0c&scoped=true"
import script from "./GlobalIngredientsList.vue?vue&type=script&lang=ts"
export * from "./GlobalIngredientsList.vue?vue&type=script&lang=ts"
import style0 from "./GlobalIngredientsList.vue?vue&type=style&index=0&id=4a726d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a726d0c",
  null
  
)

export default component.exports